<template>
  <!-- eslint-disable-next-line vue/no-restricted-v-bind -- the #EFF1F3 page ground sits outside the palette; no semantic surface token matches it (REV-903) -->
  <div class="light-theme" :style="{ background: '#EFF1F3' }">
    <template v-if="useLayout">
      <SideBar :me="me" />
      <div
        class="block flex-auto flex-shrink flex-grow"
        :class="{
          'laptop:pl-64': !isFullWidth,
          'min-h-screen laptop:pl-58': isFullWidth,
          'laptop:ml-45': hasSubmenu,
        }"
      >
        <div
          :class="{
            'mx-auto mt-24 mb-16 max-w-6xl px-10 laptop:mt-8': !isFullWidth,
            'relative min-h-full bg-surface-elevation-1': isFullWidth,
          }"
        >
          <UiNotifications />

          <RouterView :me="me" />
        </div>
      </div>
    </template>
    <template v-else-if="me">
      <RouterView :me="me" />
    </template>
    <template v-else>
      <RouterView />
    </template>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { UiNotifications, SideBar } from '@/components'
import { useMeStore } from '@/stores'

const route = useRoute()
const { me } = storeToRefs(useMeStore())

const useLayout = computed(() => {
  if (route.meta.noLayout) return false
  return !!me.value
})

const isFullWidth = computed(() => {
  return route.matched.some((r) => r.meta['fullWidth'])
})

const hasSubmenu = computed(() => {
  return route.matched.some((r) => r.meta['hasSubmenu'])
})
</script>
